// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { useAuthContext } from "@asgardeo/auth-react";
import axios from "axios";
import axiosRetry from "axios-retry";

export const useApiService = () => {
  const { getAccessToken, refreshAccessToken } = useAuthContext();

  let refreshPromise = null;

  const instance = axios.create();

  instance.interceptors.request.use(async (config) => {
    try {
      const token = await getAccessToken();
      config.headers.Authorization = `Bearer ${token}`;
    } catch (error) {
      window.location.reload();
    }
    return config;
  });

  axiosRetry(instance, {
    retries: 1,
    onRetry: async () => {
      if (!refreshPromise) {
        refreshPromise = refreshAccessToken()
          .catch(() => window.location.reload())
          .finally(() => {
            refreshPromise = null;
          });
      }
      await refreshPromise;
    },
    retryCondition: (error) => {
      return error.response?.status === 401;
    },
  });

  const getApiInstance = () => instance;

  return {
    getApiInstance,
  };
};
